import { HighDetailedStyle } from 'blaze-ui/icons/24'
import { BrandWizardIntegrationSelection } from 'components/BrandWizardIntegrationSelection/BrandWizardIntegrationSelection'
import { useModals } from 'almanac-ui/Modal'
import { NewBrandAICard } from 'screens/BrandKits/components/NewBrandAICard/NewBrandAICard'
import { FirstBrandAICard } from 'screens/BrandKits/components/NewBrandAICard/FirstBrandAICard'
import { BrandWizardNewDesignModal } from 'components/BrandWizardNewDesignModal/BrandWizardNewDesignModal'
import { useTierUsageLimits } from 'hooks/useTierUsageLimits'
import { PricePill } from 'blaze-ui/Pricing/PricePill/PricePill'
import { TierUpgradeModal } from 'components/TierUpgradeModal/TierUpgradeModal'
import { BrandCardSize } from '../../BrandAICard/Types'
import { BrandVisualKit } from 'types'
import { observer } from 'mobx-react-lite'

interface Props {
  size?: BrandCardSize
  title?: string
  onConfirm?: (kit: BrandVisualKit) => void
}

export const NewBrandStyleCard = observer(({ size = 'sm', title = 'New Brand Style', onConfirm }: Props) => {
  const { openModal } = useModals()
  const { atLimit, nextTierPlan, currentTierPlan } = useTierUsageLimits({ limitKey: 'brand_kits' })
  const shouldEnforceTierLimit = atLimit && nextTierPlan && currentTierPlan

  const handlePress = () =>
    openModal(BrandWizardIntegrationSelection, {
      onConfirm: (kit) => {
        if (onConfirm) {
          onConfirm(kit)
          return
        }

        openModal(BrandWizardNewDesignModal, { brandVisualKit: kit })
      },
    })

  return (
    <NewBrandAICard
      title={title}
      size={size}
      upgradeBadge={shouldEnforceTierLimit ? <PricePill plan={nextTierPlan.key} /> : undefined}
      onPress={() => {
        if (shouldEnforceTierLimit) {
          openModal(TierUpgradeModal, {
            reason: 'limit_reached',
            feature: 'Brand Styles',
            upgradeTier: nextTierPlan,
            currentTier: currentTierPlan,
            onUpgrade: handlePress,
          })
        } else {
          handlePress()
        }
      }}
    />
  )
})

export const FirstBrandStyleCard = () => {
  const { openModal } = useModals()

  const handlePress = () =>
    openModal(BrandWizardIntegrationSelection, {
      onConfirm: (kit) => {
        openModal(BrandWizardNewDesignModal, { brandVisualKit: kit })
      },
    })

  return <FirstBrandAICard title="New Brand Style" onPress={handlePress} icon={HighDetailedStyle} />
}
